import React from 'react';
import {NodeCategory} from '../../../interface';
import {Badge, BadgeColor} from '../../../../badge/badge';

interface Props {
    category: NodeCategory;
}

const colorByCategory: Record<NodeCategory, BadgeColor> = {
    [NodeCategory.PROCESS]: 'gray',
    [NodeCategory.CONTINUANT]: 'gray',
    [NodeCategory.PREREQUISITE]: 'green',
    [NodeCategory.EFFECT]: 'orange',
    [NodeCategory.COMPUTED]: 'teal',
    [NodeCategory.IN_PLACE]: 'purple'
};

const labelByCategory: Record<NodeCategory, string> = {
    [NodeCategory.PROCESS]: 'process',
    [NodeCategory.CONTINUANT]: 'continuant',
    [NodeCategory.PREREQUISITE]: 'prerequisite',
    [NodeCategory.EFFECT]: 'effect',
    [NodeCategory.COMPUTED]: 'computed',
    [NodeCategory.IN_PLACE]: 'in-place'
};

export function NodeCategoryTag({category}: Props) {
    return <Badge label={labelByCategory[category]} color={colorByCategory[category]} />;
}
